<template>
  <PflegeBaseComponentTemplate
    v-editable="props.blok"
    :actions-alignment="props.blok.actionsAlignment"
    :background-color="getPflegeColorName(props.blok.backgroundColor)"
    :data-uid="props.blok._uid"
    :heading="props.blok.heading"
    :heading-tag="props.blok.headingTag"
    :text-align="props.blok.textAlign"
  >
    <template v-if="willRender(props.blok.content)" #default>
      <RichtextResolver :blok="props.blok.content" />
    </template>

    <template v-if="props.blok.actions?.length" #actions>
      <WPElementButton :blok="props.blok.actions[0]" />
    </template>
  </PflegeBaseComponentTemplate>
</template>

<script setup lang="ts">
import { PflegeBaseComponentTemplate } from '@webcarelbj/shared-components'
import { BlokBaseComponentTemplate, BlokProps } from '../../types/blok'
import { RichtextResolver, WPElementButton } from '../'
import { getPflegeColorName, willRender } from '../../utils'
import { ButtonBlok } from '../WPElementButton'
import { DocContent } from '../../types/richtext'

export interface ClosingComponentBlok extends BlokBaseComponentTemplate {
  content: DocContent
  actions?: ButtonBlok[];
  component: 'ClosingComponent'
  headingTag?: '' | 'h3' | 'h4' | 'h5'
}

const props = defineProps<BlokProps<ClosingComponentBlok>>()
</script>
